import { Typography, TypographyProps } from "@mui/material";

interface IProps extends TypographyProps {
  text: string;
}
const Text: React.FC<IProps> = ({ text, ...props }) => {
  return (
    <Typography variant="subtitle1" color="text.secondary" {...props}>
      {text}
    </Typography>
  );
};

export default Text;
